import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/fashion-partners.jpg")